import React, { useState } from "react";

function FenceRemovalFAQs() {
  const [openAccordionIndex, setOpenAccordionIndex] = useState(null);

  const toggleAccordion = (index) => {
    // Toggle the current accordion's open state
    setOpenAccordionIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const accordionItems = [
    {
      title: "Do I need to remove the fence myself?",
      content: `
No! Our fence removal specialists handle the entire process, including fence post removal, concrete footings, and old fence materials.
      `,
    },
    {
      title: "What’s the best way to remove a fence?",
      content: `
      Hiring a professional junk removal service like Junk Droid is the best way to ensure safe and efficient fence removal.
      `,
    },
    {
      title: "Can you remove a fence in poor condition?",
      content: `
       Yes! Whether it’s rotting wood, rusted chain-link, or damaged vinyl fencing, we remove fences in any condition.
      `,
    },
    {
      title: "How much space will I need for a new fence?",
      content: `
         After removal, we ensure your property line is clear for a fence replacement project.
        `,
    },
  ];

  return (
    <div>
      <main>
        <div className="accordion">
          {accordionItems.map((item, index) => (
            <div className="accordion-item" key={index}>
              <div
                className="accordion-item-header"
                onClick={() => toggleAccordion(index)}
                style={{ cursor: "pointer" }}
              >
                <span className="accordion-item-header-title">
                  {item.title}
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                  />
                </svg>
              </div>
              <div
                className="accordion-item-description-wrapper"
                style={{
                  display: openAccordionIndex === index ? "block" : "none",
                }}
              >
                <div className="accordion-item-description furniture-faq">
                  <hr />
                  <p>{item.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export default FenceRemovalFAQs;
